import { render } from "./PassengerList.vue?vue&type=template&id=0a8294a9&scoped=true&lang=pug"
import script from "./PassengerList.vue?vue&type=script&lang=ts"
export * from "./PassengerList.vue?vue&type=script&lang=ts"

import "./PassengerList.vue?vue&type=style&index=0&id=0a8294a9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0a8294a9"

export default script